import React, { useState } from 'react';

import { Divider, Header } from '@rbilabs/universal-components';
import * as Updates from 'expo-updates';

import { EnvPicker } from 'components/env-picker';
import useEffectOnce from 'hooks/use-effect-once';
import { appVersion, binaryRuntimeAppVersionWithBuildNumber } from 'utils/app-version-info';
import { getDeviceId } from 'utils/device-id';
import { allowEnvPicker, env, getCurrentCommitHash, region } from 'utils/environment';

import { EnvItem, HiddenSection } from './components';
import { InternalDiagnostics } from './internal-diagnostics';

export const Configs = () => {
  const [deviceId, setDeviceId] = useState<string>('');

  useEffectOnce(() => {
    getDeviceId().then(deviceIdResult => setDeviceId(deviceIdResult || ''));
  });

  return (
    <>
      <Divider />
      <Header pt={4} variant="headerFour">
        Device Information
      </Header>
      <EnvItem envKey="Device Id" value={deviceId?.toLowerCase()} />

      <Divider />

      <Header pt={4} variant="headerFour">
        Update OTA Build Info
      </Header>
      <EnvItem envKey="OTA App Version" value={appVersion} />
      <EnvItem envKey="Commit Hash" value={getCurrentCommitHash()} />
      <EnvItem envKey="Build Date" value={Updates.createdAt?.toLocaleString()} />
      <EnvItem envKey="Update Id" value={Updates.updateId} />
      <EnvItem envKey="Update Channel" value={Updates.channel} />
      <EnvItem envKey="Is Embedded Launch?" value={Updates.isEmbeddedLaunch + ''} />

      <Header pt={4} variant="headerFour">
        Binary runtime info
      </Header>
      <EnvItem
        envKey="Binary app runtime version with build number"
        value={binaryRuntimeAppVersionWithBuildNumber}
      />

      {allowEnvPicker && (
        <>
          <Divider />
          <HiddenSection
            title={`Env Config (current: ${env()}, ${region})`}
            content={<EnvPicker isDiagnosticsScreen />}
          />
        </>
      )}
      <Divider />

      <InternalDiagnostics />
    </>
  );
};
